<div class="p-field">
  @if (props.label) {
    <label>{{ props.label }}</label>
  }

  <textarea pTextarea
            [formControl]="formControl"
            [rows]="props.rows || 4"
            [placeholder]="props.placeholder || ''"
            [attr.disabled]="props.disabled ? true : null"
            class="w-full">
  </textarea>

  @if (maxLength) {
    <div class="counter-container" [class.over-limit]="isOverLimit">
      <span class="counter-text">{{ counterText }}</span>
      @if (isOverLimit && validationMessage) {
        <span class="validation-message">{{ validationMessage }}</span>
      }
    </div>
  }

  @if (showError && !isOverLimit) {
    <small class="p-error">
      <formly-validation-message [field]="field" />
    </small>
  }
</div>
